import { render, staticRenderFns } from "./BacTeamCard.vue?vue&type=template&id=0d635eae&scoped=true&"
import script from "./BacTeamCard.vue?vue&type=script&lang=ts&"
export * from "./BacTeamCard.vue?vue&type=script&lang=ts&"
import style0 from "./BacTeamCard.vue?vue&type=style&index=0&id=0d635eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d635eae",
  null
  
)

export default component.exports